/* eslint-disable */
export default {
  forward: '착신 전환',
  cancel: '취소',
  customNumber: '사용자 지정 번호',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
